// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartActionsStyles } from "@gcg/Overrides/Widgets/Cart/CartActions";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartActionsStyles.buttonsOverflowPopup= {
    buttonProps: {
        css: css`
            padding: 0;
            height: auto;
            width: auto !important;
            border: 0;
        `,
    },
    cssOverrides: {
        wrapper: css`
            width: auto;
            height: auto;
            padding: 0;
        `,
        menu: css`
            left: auto !important;
            right: 10px;
            width: 200px;
            padding: 10px 5px;
        `,
        menuItem: css`
            display: inline;
            padding: 0;
            width: auto;
            & > * {
            }
            // XNG-Change GCG-416
            &:hover,
            &:active,
            &:focus {
                background: transparent;
                color: ${getColor("primary.main")} !important;
            }
        `,
    },
};

